import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import { WIDGET_PAGE_NAME } from '../../constants/service/app/widgetConstants';
import WidgetForm from '../../views/widget/detail/WidgetForm';
import useCreateWidget from '../../hooks/widget/useCreateWidget';
import usePrompt from '../../hooks/common/usePrompt';

const WidgetCreate = () => {
  const { createWidget, isSuccess, isLoading } = useCreateWidget();

  usePrompt(!(isSuccess || isLoading), '편집을 중단하시겠습니까?');

  return (
    <PageTemplate pageName={WIDGET_PAGE_NAME.WIDGET_CREATE}>
      <WidgetForm onFinish={createWidget} />
    </PageTemplate>
  );
};

export default WidgetCreate;
